import { normalizeValue } from './formatters';

export const MX_STATE_ISO = Object.freeze({
  aguascalientes: 'MX-AGU',
  'baja california': 'MX-BCN',
  'baja california sur': 'MX-BCS',
  campeche: 'MX-CAM',
  coahuila: 'MX-COA',
  colima: 'MX-COL',
  chiapas: 'MX-CHP',
  chihuahua: 'MX-CHH',
  'ciudad de mexico': 'MX-CMX',
  durango: 'MX-DUR',
  guanajuato: 'MX-GUA',
  guerrero: 'MX-GRO',
  hidalgo: 'MX-HID',
  jalisco: 'MX-JAL',
  mexico: 'MX-MEX',
  michoacan: 'MX-MIC',
  morelos: 'MX-MOR',
  nayarit: 'MX-NAY',
  'nuevo leon': 'MX-NLE',
  oaxaca: 'MX-OAX',
  puebla: 'MX-PUE',
  queretaro: 'MX-QUE',
  'quintana roo': 'MX-ROO',
  'san luis potosi': 'MX-SLP',
  sinaloa: 'MX-SIN',
  sonora: 'MX-SON',
  tabasco: 'MX-TAB',
  tamaulipas: 'MX-TAM',
  tlaxcala: 'MX-TLA',
  veracruz: 'MX-VER',
  yucatan: 'MX-YUC',
  zacatecas: 'MX-ZAC',
});
export const getISOStateCode = (stateName = '') => {
  if (!stateName) return null;
  const normalized = normalizeValue(stateName);
  return MX_STATE_ISO[normalized] || null;
};
